import { Injectable } from '@angular/core';
import { NavTabModel } from '../model/nav-tab.dto';
import { Observable, Subject } from 'rxjs';
import { LocalConfigService } from '../../services/local/local-config.service';
import { JSONHelper } from '../../shared/helpers/json.helper';
import { StringUtilsHelper } from '../../shared/helpers/strings.helper';

@Injectable({
  providedIn: 'root'
})
export class NavStorageService implements Storage {

  private apiStorage = window.sessionStorage;
  private tabs$ = new Subject<NavTabModel[]>;
  private listOrder: Map<number, any> = new Map();

  constructor(private localStorage: LocalConfigService){

  }

  updateTabs(): void{
    const resp: NavTabModel []=[];
    if (this.length > 0) {
      this.listOrder = this.recoveryKeysNav();
    }
    this.listOrder.forEach((value, key) => {
      const navTab =this.getItem<NavTabModel>(value.key);      
      if (navTab !== null){
        value.active = navTab.activeTab;
        resp.push(navTab);
      }
    });
    if (resp.length === 1 && this.exists("patient-info")) {
      this.clear();
    }
    this.tabs$.next(resp);
    this.save(this.listOrder);
  }

  getAllTabs(): Observable<NavTabModel[]>{
    return this.tabs$.asObservable();
  }

  get length(): number {
    return this.apiStorage.length;
  }

  setItem(key: string, navModel: unknown): void {
    if (!this.existKey(key)) {
      let pos = this.length;
      let active = (navModel as NavTabModel).activeTab;
      this.listOrder.set(pos, { key: key, active: active});      
      this.save(this.listOrder);
    }    
    const value = JSON.stringify(navModel);
    this.apiStorage.setItem(key, value);
    this.updateTabs();
  }
  
  getItem<T>(key: string): T {
    const value = this.apiStorage.getItem(key);
    if (value !== null)
      return JSON.parse(value) as T;
    return null; 
  }

  getItemByIndex<T>(index: number): T  | null{
    const navLabel = this.listOrder.size > 0 ? this.listOrder.get(index) : "";
    const value = this.getItem<T>(navLabel.key);    
    if (value !== null)
      return value;
    return null; 
  }

  clear(): void {
    this.apiStorage.clear();
    this.listOrder = new Map();
    this.updateTabs();
  }

  key(index: number): string | null {
    return this.apiStorage.key(index);
  }

  removeItem(key: string): void {
    this.apiStorage.removeItem(key);
    this.removeKeyByKey(key);
    this.updateTabs();
  }

  exists(key:string): boolean{
    const aux = this.apiStorage.getItem(key);
    if(aux == null) 
      return false;
    return true;
  }

  removeKeyByKey(key: string){
    let mapTmp: Map<number, string> = new Map();
    let i = 0;
    for(let entry of this.listOrder.entries()){
      if(entry[1].key !== key){
        mapTmp.set(i, entry[1]);
        i += 1;
      }
    }
    this.listOrder = mapTmp;
    this.save(this.listOrder);
  }

  existKey(key: string){
    let result = false;
    for(let entry of this.listOrder.entries()){
      if (entry[1].key === key) {
        result = true;
      }
    }
    return result;
  }

  getIdByKey(key: string){
    let result = -1;
    for(let entry of this.listOrder.entries()){
      if (entry[1].key === key) {
        result = entry[0];
      }
    }
    return result;
  }

  recoveryKeysNav(){
    let recovery = this.localStorage.getElement("listNav");
    if (StringUtilsHelper.notNullOrUndefinedOrEmpty(recovery)) {
      let obj = JSONHelper.objToMap(recovery);
      return obj;
    }
    return new Map();
  }

  save(map: Map<number, any>){
    let jsonList = JSONHelper.mapToJson<number, any>(map);
    this.localStorage.saveElement("listNav", jsonList);
  }
}
